import ResultItem from "./ResultItem";

const SearchDropdown = ({ 
    query, 
    searchResults, 
    searchHistory, 
    onSelect, 
    onHistoryClick, 
    onClearHistory, 
    onRemoveHistoryItem 
}) => {
    if (query.length > 0) {
        return (
            <div className="search-dropdown">
                <div className="search-header">Search Results</div>
                {searchResults.length === 0 ? (
                    <div className="no-result">No users found.</div>
                ) : (
                    searchResults.map(user => (
                        <ResultItem 
                            key={user.id} 
                            item={{ ...user, type: 'user' }} 
                            onClick={() => onSelect(user)} 
                        />
                    ))
                )}
            </div>
        );
    }

    return (
        <div className="search-dropdown">
            <div className="search-header">
                <span>Recent</span>
                {searchHistory.length > 0 && (
                    <span className="clear-btn" onClick={onClearHistory} style={{cursor: "pointer"}}>
                        Clear All
                    </span>
                )}
            </div>

            {searchHistory.length === 0 ? (
                <div className="no-result">No recent searches.</div>
            ) : (
                searchHistory.map(item => (
                    <ResultItem 
                        key={item.id} 
                        item={item} 
                        onClick={() => onHistoryClick(item)}
                        onRemove={onRemoveHistoryItem} 
                    />
                ))
            )}
        </div>
    );
};

export default SearchDropdown;